/** Campaigns API calls (typed). */

import {
  apiDelete,
  apiGet,
  apiPatch,
  apiPost,
  type PaginatedResponse,
  type QueryParams,
} from "@/lib/api-client";
import type { ApiCampaign, ApiCampaignReport } from "./campaigns.adapter";

export interface CampaignsListParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  platform?: string;
  archived?: boolean;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
}

export const campaignsApi = {
  list: (params: CampaignsListParams = {}) =>
    apiGet<PaginatedResponse<ApiCampaign>>("/campaigns", params as QueryParams),
  report: (id: string) => apiGet<ApiCampaignReport>(`/campaigns/${id}/report`),
  create: (body: Record<string, unknown>) => apiPost<ApiCampaign>("/campaigns", body),
  update: (id: string, body: Record<string, unknown>) =>
    apiPatch<ApiCampaign>(`/campaigns/${id}`, body),
  stop: (id: string, reason: string) => apiPost<ApiCampaign>(`/campaigns/${id}/stop`, { reason }),
  finish: (id: string) => apiPost<ApiCampaign>(`/campaigns/${id}/finish`),
  reactivate: (id: string) => apiPost<ApiCampaign>(`/campaigns/${id}/reactivate`),
  logResult: (
    id: string,
    body: { date: string; spentUsd: number; resultsCount: number; note?: string },
  ) => apiPost(`/campaigns/${id}/results`, body),
  share: (id: string) => apiPost<{ shareToken: string }>(`/campaigns/${id}/share`),
  revokeShare: (id: string) => apiDelete<{ shareToken: null }>(`/campaigns/${id}/share`),
  archive: (id: string) => apiDelete<ApiCampaign>(`/campaigns/${id}`),
  restore: (id: string) => apiPost<ApiCampaign>(`/campaigns/${id}/restore`),
};
